<template>
    <div class="container mt-5 py-5">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div
                    class="row g-4 align-items-center p-4 text-center"
                >
                    <!-- Text Section -->
                    <div class="col-12">
                        <h2 class="mb-5">Worried about something?</h2>

                        <p class="mb-5">
                            Are you concerned about your safety or the safety of someone else? <a href="https://www.kingstrust.org.uk/contact-us" target="_blank" rel="noopener"><b>Let us know.</b></a>
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>